import React, { useContext, useState } from 'react';
import { Form, Button} from 'react-bootstrap';
import NoticeModal from '../../components/NoticeModal';
import axios from 'axios';
import { Store } from '../../Store';
import ToastIt from '../../components/Toast';

const AdminNotice = () => {
      const { state, dispatch } = useContext(Store);  
      const {baseUrl, noticeContent} = state;

  const [newContent, setNewContent] = useState(noticeContent?.noticeContent);
  const [newMomoPhone, setNewMomoPhone] = useState(noticeContent?.momoPhoneNumber);
  const [newMomoName, setNewMomoName] = useState(noticeContent?.momoAccountName);
  // const [newNetwork, setNetwork] = useState(noticeContent?.momoNetwork);

  const [showModal, setShowModal] = useState(false);

      const [showToast, setShowToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
      const [variance, setVariance] = useState('');

  const handleNoticeSave = async () => {
    try {
      const updatedContent = {
        ...noticeContent,
        noticeContent: newContent,
      };
      await axios.put(`${baseUrl}/extra/notice`, { noticeContent: newContent });
      dispatch({ type: 'SET_NOTICE_CONTENT', payload: updatedContent.noticeContent });
      setVariance("success");
      setToastMessage("Notice message updated successfully");
      setShowToast(true)
    } catch (error) {
      setVariance("danger");
      setToastMessage("Error updating notice content:", error);
      setShowToast(true)
    }
  };

  const handleMomoSave = async () => {
    try {
      const updatedContent = {
        ...noticeContent,
        momoPhoneNumber: newMomoPhone,
        momoAccountName: newMomoName,
        // momoNetwork: newNetwork,
      };

      await axios.put(`${baseUrl}/extra/momo-details`, {
        momoPhoneNumber: newMomoPhone,
        momoAccountName: newMomoName,
        // momoNetwork: newNetwork,
      });

      dispatch({ type: 'SET_NOTICE_CONTENT', payload: updatedContent });
      setVariance("success");
      setToastMessage("Notice message updated successfully");
      setShowToast(true);
    } catch (error) {
      console.log(error)
      setVariance("danger");
      setToastMessage("Error updating notice content:", error);
      setShowToast(true);
    }
  }

const handleShow = () => setShowModal(true);

  return (

    <div className='d-flex flex-column align-items-center justify-content-center text-center'>      
          <h3 className='text-center text-primary my-3'>EXTRA INFORMATION</h3>
          {/* <hr/> */}
    <Form>
        <Form.Group controlId="noticeContent">
          <Form.Label>Edit Notice Content</Form.Label>
          <Form.Control
            as="textarea"
            rows={6}
            cols={50}
            value={newContent}
            onChange={(e) => setNewContent(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="formPhoneNumber" className='w-100'>
        <Button variant="success" className='mt-1 flex-1' onClick={handleNoticeSave}>
          Save Changes
        </Button>{' '}
      <Button variant="warning" onClick={handleShow} className="mt-1">
        Checkout current Notice
      </Button>
      </Form.Group>
      </Form>
    <Form className='mt-2'>
        <Form.Group controlId="formPhoneNumber">
        <Form.Label>Momo Phone Number</Form.Label>
        <Form.Control
          type="text"
          value={newMomoPhone}
          onChange={(e) => setNewMomoPhone(e.target.value)}
        />
        <Form.Label>Momo Account Name</Form.Label>
        <Form.Control
          type="text"
          value={newMomoName}
          onChange={(e) => setNewMomoName(e.target.value)}
        />
        {/* <Form.Label>Network</Form.Label>
        <Form.Control
          type="text"
          value={newNetwork}
          onChange={(e) => setNetwork(e.target.value)}
        /> */}
      </Form.Group>
      <Form.Group>
        <Button variant="success" className='w-100 mt-1' onClick={handleMomoSave}>
          Save Changes
        </Button>{" "}
      {/* <Button variant="warning" onClick={handleShow} className="mt-1">
        Checkout Momo Details
      </Button> */}
      </Form.Group>
      </Form>

      <NoticeModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        noticeContent={noticeContent}
      />
            <ToastIt 
      Variance={variance} 
      Message={toastMessage} 
      ShowToast={showToast} 
      OnClose={() => setShowToast(false)}
      />
    </div>
  );
};

export default AdminNotice;